import React, { useState, useEffect, useRef } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import axios from "axios";
import * as language from "../../utils/language.js";
import * as navigation from "../../utils/navigation.js";
import menuImage from "../../images/icons/Menu.png";

//========================================================================
// Burger-Menü
const Menu = observer(() => {
  const [isOpen, setIsOpen] = useState(false);
  const [collapsedItems, setCollapsedItems] = useState({});
  const [nav, setNav] = useState([]);
  const menuRef = useRef(null);

  //========================================================================
  // anzeigen von Menü
  useEffect(() => {
    // IP-Adresse des Servers
    let url = window.location.hostname;
    const fetchNavConfig = async () => {
      try {
        const url =
          window.location.port === "3000"
            ? `http://${window.location.hostname}:${globalVars.httpPort}/project/pages/navigation.json`
            : `/project/pages/navigation.json`;

        const response = await axios.get(url);
        const data = response.data;
        setNav(data);
      } catch (error) {
        // console.error("Error loading the JSON:", error);
      }
    };

    fetchNavConfig();
  }, []);

  //========================================================================
  // Mausklicks auserhalb des Menüs behandeln
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  //========================================================================
  // Klick auf Menü
  const handleButtonClick = () => {
    if (globalVars.auth.loggedIn) {
      setIsOpen(!isOpen);
      setCollapsedItems({});
    }
  };

  //========================================================================
  // Menü aus- und einklappen
  const toggleCollapse = (index) => {
    setCollapsedItems((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  //========================================================================
  // Element lesbar und beschreibbar
  const authRead = (item) => {
    if (item.authRead) {
      return globalVars.auth.read[item.authRead];
    } else {
      return true;
    }
  };

  const authWrite = (item) => {
    if (item.authWrite) {
      return globalVars.auth.write[item.authWrite];
    } else {
      return true;
    }
  };

  //========================================================================
  // Seitenwechsel
  const changePage = (item) => {
    if (item.path === "__system/users") {
      navigation.changePage("custom", "__system/users");
      setIsOpen(false);
      setCollapsedItems({});
    } else if (authWrite(item)) {
      navigation.changePage("custom", item.path);
      setIsOpen(false);
      setCollapsedItems({});
    }
  };

  //========================================================================
  // verschachtelte Elemente auflösen
  const renderMenuItems = (items, parentIndex = "") => {
    let itemsToRender = [...items];

    if (parentIndex === "") {
      const userEntry =
        language.displayText(["Benutzer: ", "utente: ", "user: "]) +
        globalVars.auth.name;
      const user = {
        name: [userEntry, userEntry, userEntry],
        path: "__system/users",
      };
      itemsToRender.push(user);
    }

    return itemsToRender.map((item, index) => {
      const currentIndex = parentIndex ? `${parentIndex}-${index}` : `${index}`;
      const isCollapsed = collapsedItems[currentIndex] || false;
      const hasSubItems =
        item.subItem && item.subItem.items && item.subItem.items.length > 0;
      const backgroundColor = index % 2 === 0 ? "#444" : "#555";

      if (authRead(item)) {
        return (
          <div
            key={currentIndex}
            style={{
              margin: "5px 0",
              padding: `calc(${globalVars.scaleFactor} * 10px)`,
              borderRadius: "5px",
              backgroundColor,
            }}
          >
            {item.path ? (
              <div onClick={() => changePage(item)} style={styles.menuLink}>
                {language.displayText(item.name)}
              </div>
            ) : (
              <div>
                <div
                  onClick={() =>
                    hasSubItems &&
                    item.subItem.collapse &&
                    toggleCollapse(currentIndex)
                  }
                  style={{
                    ...styles.menuLink,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {language.displayText(item.name)}
                  {hasSubItems && (
                    <span
                      style={{
                        marginLeft: `calc(${globalVars.scaleFactor} * 10px)`,
                      }}
                    >
                      {isCollapsed ? "▼" : item.subItem.collapse ? "▶" : ""}
                    </span>
                  )}
                </div>
                {hasSubItems && (!item.subItem.collapse || isCollapsed) && (
                  <div
                    style={{
                      marginLeft: `calc(${globalVars.scaleFactor} * 20px)`,
                      paddingLeft: `calc(${globalVars.scaleFactor} * 10px)`,
                      borderLeft: "1px solid #ccc",
                    }}
                  >
                    {renderMenuItems(item.subItem.items, currentIndex)}
                  </div>
                )}
              </div>
            )}
          </div>
        );
      }
    });
  };

  //========================================================================
  // CSS-Styles
  const styles = {
    menuLink: {
      color: "#fff",
      cursor: "pointer",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      textDecoration: "none",
      transition: "background-color 0.3s",
    },
  };

  //========================================================================
  // Menü anzeigen
  return (
    <div
      style={{
        position: "relative",
        fontSize: `calc(${globalVars.scaleFactor} * 20px)`,
      }}
      ref={menuRef}
    >
      <button
        onClick={handleButtonClick}
        style={{
          width: "50px",
          height: "50px",
          backgroundColor: "#333",
          color: "#fff",
          padding: "10px 20px",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          backgroundImage: `url(${menuImage})`,
        }}
      ></button>
      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "70px",
            left: "0",
            backgroundColor: "#333",
            border: "1px solid #ccc",
            borderRadius: "5px",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
            padding: "10px",
            zIndex: 1000,
            minWidth: `calc(${globalVars.scaleFactor} * 600px)`,
            maxHeight: `calc(${globalVars.pageSize.height} - 42px)`,
            overflowY: "auto",
          }}
        >
          {renderMenuItems(nav)}
        </div>
      )}
    </div>
  );
});

export default Menu;
